import React from "react";
import { InputAdornment, Stack } from "@mui/material";
import FieldBridge from "./FieldBridge";
import { StyledTextField } from "customStyled";
import { PasteButton } from "Reuse/UI";
import { withTrimHandler } from "utils/reactiveFormFunc";
import FormControlUI from "./FormControlUI";
import { autocompleteToken } from "utils";
import FieldErrorIcon from "./FieldErrorIcon";

/**
 * Text input with a Paste button. `errorMsg` ([{ validation, errorMsg }])
 * shows the message of a failing rule on the error icon, like FormInput.
 */
const PasteInput = ({ label, handlePaste, id, placeholder, autoComplete, required, attr = {}, errorMsg = [] }) => {
  return (
    <React.Fragment>
      <FieldBridge
        name={id}
        render={({ handler, touched, invalid, hasError, errors }) => {
          const isError = touched && invalid;
          return (
            <FormControlUI
              label={label}
              required={required}
              id={id}
              isError={isError}
              errorMsg={errorMsg}
              hasError={hasError}
              errors={errors}
            >
              <StyledTextField
                id={id}
                name={id}
                {...withTrimHandler(handler)}
                placeholder={placeholder}
                autoComplete={autocompleteToken(autoComplete)}
                variant="outlined"
                onPaste={(event) => handlePaste(event, id)}
                required={required || false}
                sx={{
                  pr: 0,
                }}
                inputProps={{ ...attr }}
                endAdornment={
                  <Stack direction="row" sx={{ alignItems: "center" }}>
                    {isError ? (
                      <InputAdornment position="end">
                        <FieldErrorIcon />
                      </InputAdornment>
                    ) : null}
                    <PasteButton clickEvent={(event) => handlePaste(event, id)} />
                  </Stack>
                }
                aria-describedby={`${id}-error-text`}
              />
            </FormControlUI>
          );
        }}
      />
    </React.Fragment>
  );
};

export default PasteInput;
